import classNames from 'classnames'
import { Fragment, h, JSX } from 'preact'

import { Image, ImageProps } from '../../components/image/image'
import { Loader } from '../../components/loader/loader'
import { PluginTheme } from '../../types'
import { ResponseBlock, ResponseBlockProps } from './response-block'

export interface ResponseProps {
    class?: string
    modifier?: string
    isLoading?: boolean
    title: string
    theme: PluginTheme
    poster?: ImageProps
    film?: ResponseFilm
    blocks?: ResponseBlockProps[]
}

export interface ResponseFilm {
    title: string
    datetime: string
    seats?: ResponseSeats
}

interface ResponseSeats {
    title: string
    tickets: string[]
}

export const Response = (props: ResponseProps): JSX.Element => {
    const className = classNames('response', props.modifier, props.class, `h-theme-${props.theme}`)

    return (
        <div class={className}>
            <Loader isHidden={!props.isLoading} />
            <div
                className={classNames(
                    'h-container response__container',
                    props.isLoading && 'is-loading',
                )}
            >
                <h1 className="response__title">{props.title}</h1>
                {props.film && (
                    <div className="response__info">
                        {props.poster && (
                            <Image
                                class="response__poster"
                                modifier="image--fluid"
                                {...props.poster}
                            />
                        )}
                        <div className="response__film">
                            <h2 className="response__film-title">{props.film.title}</h2>
                            <p className="response__datetime">{props.film.datetime}</p>
                            {props.film.seats && (
                                <>
                                    <h2 className="response__seats-title">
                                        {props.film.seats.title}
                                    </h2>
                                    <div className="response__seats">
                                        {props.film.seats.tickets.map((row, index) => (
                                            <p key={index} className="response__seat">
                                                {row}
                                            </p>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                )}
                {props.blocks?.map((block, index) => <ResponseBlock key={index} {...block} />)}
            </div>
        </div>
    )
}
